"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoUrls = exports.getDownloadUrl = exports.ctx = exports.service = exports.createService = void 0;
var tslib_1 = require("tslib");
var video_1 = require("@wix/wix-vod-api-site-based/dist/src/public/services/video/video");
var to_error_1 = require("../../parsers/to-error");
var context_1 = require("@wix/wix-vod-shared/dist/src/common/utils/context");
var hosts_1 = require("@wix/wix-vod-constants/dist/env/hosts");
var experiments_1 = require("@wix/wix-vod-shared/dist/src/common/utils/experiments");
var video_2 = require("@wix/wix-vod-gql-api/dist/src/public/video/video");
var channel_1 = require("@wix/wix-vod-gql-api/dist/src/public/channel/channel");
var globalTypes_1 = require("@wix/wix-vod-gql-api/dist/src/public/generated/globalTypes");
var createService = function () { return new video_1.PublicVideo(); };
exports.createService = createService;
exports.service = (0, exports.createService)();
exports.ctx = (0, context_1.createCtx)(exports.service);
var getDownloadUrl = function (videoId, channelId, instance, baseUrl) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var publicVideoService;
    return (0, tslib_1.__generator)(this, function (_a) {
        if ((0, experiments_1.isGraphAPIEnabled)()) {
            publicVideoService = new video_2.PublicVideoService(instance, baseUrl);
            return [2 /*return*/, publicVideoService.getDownloadUrl(videoId)];
        }
        return [2 /*return*/, video_1.PublicVideo.getDownloadUrl(hosts_1.PRODUCTION_HOSTS.catalog, videoId, channelId, instance)];
    });
}); };
exports.getDownloadUrl = getDownloadUrl;
var getVideoUrls = function (videoId, channelId, instance, baseUrl) {
    if ((0, experiments_1.isGraphAPIEnabled)()) {
        if (channelId) {
            var publicChannelService = new channel_1.PublicChannelService(instance, baseUrl);
            return publicChannelService.getChannelVideoPlayUrls(videoId, channelId);
        }
        var publicVideoService = new video_2.PublicVideoService(instance, baseUrl);
        return publicVideoService.getPlayUrls({
            id: videoId,
            type: globalTypes_1.VideoPlayType.CONTENT,
        });
    }
    return exports.service
        .getVideoUrls(videoId, channelId, instance)
        .then(function (response) { return response.data; })
        .catch(to_error_1.toError);
};
exports.getVideoUrls = getVideoUrls;
//# sourceMappingURL=video.js.map